module.exports = __webpack_public_path__ + "static/img/15.639faa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/15.jpg
// module id = evfb
// module chunks = 0